@for (task of taskVms; track task.orderId) {
  <tidy-card class="restock-task-card">
    <tidy-row
      [alignLastItemRight]="true"
      class="vertical-align-center extra-bottom-padding">
      <div class="vertical-align-middle" style="flex: 1;">
        <tidy-image
          [src]="'assets/svg/cube-outline.svg'"
          class="header-size"
          style="margin-right: 5px;" />
        <tidy-text
          [body]="'Restocking'"
          class="bold" />
      </div>
      <span [class]="'restock-status-chip ' + task.statusClass">{{ task.statusLabel | translate }}</span>
    </tidy-row>

    @if (task.notCompletedMessage) {
      <tidy-row>
        <tidy-text
          [helper]="task.notCompletedMessage" />
      </tidy-row>
    }

    @if (task.showItems) {
      @for (item of task.items; track item.name) {
        <div class="restock-task-item-row">
          <div class="restock-item-preview">
            <div class="restock-item-thumb">
              <tidy-image
                [src]="item.icon"
                class="restock-item-thumb-icon" />
            </div>
            <div class="restock-item-body">
              <div class="restock-item-title-row">
                <tidy-text
                  [body]="item.name"
                  [translate]="false"
                  [class]="item.strikethrough ? 'bold restock-task-item-struck' : 'bold'" />
                <div class="restock-item-trailing">
                  <span [class]="'restock-status-chip ' + item.statusClass">{{ item.statusLabel | translate }}</span>
                </div>
              </div>
              @if (item.stockText) {
                <div class="restock-line-row">
                  <tidy-image
                    [src]="'assets/svg/cube-outline.svg'"
                    class="body-size restock-item-meta-icon" />
                  <tidy-text
                    [helper]="item.stockText"
                    [translate]="false" />
                </div>
              }
            </div>
          </div>
        </div>
      }
    }

    @if (task.note || task.editing) {
      @if (task.editing) {
        <tidy-textarea
          [label]="'Note to Pro'"
          [(ngModel)]="task.noteDraft"
          [icon]="'assets/svg/create-outline.svg'" />
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-text
            [actionBody]="'Cancel'"
            (action)="cancelEditNote(task)"
            class="link" />
          <tidy-text
            [actionBody]="task.saving ? 'Saving…' : 'Save Note'"
            (action)="onSaveNote(task)"
            class="link" />
        </tidy-row>
      } @else {
        <tidy-row
          [alignLastItemRight]="editable"
          class="vertical-align-center">
          <div class="vertical-align-middle" style="flex: 1;">
            <tidy-image
              [src]="'assets/svg/create-outline.svg'"
              class="body-size"
              style="margin-right: 5px;" />
            <tidy-text
              [helper]="task.note"
              [translate]="false" />
          </div>
          @if (editable) {
            <tidy-small-button
              [smallIconButton]="true"
              [image]="'assets/svg/create-outline.svg'"
              (buttonClick)="startEditNote(task)"
              style="margin-left: 8px;" />
          }
        </tidy-row>
      }
    } @else if (editable) {
      <tidy-row>
        <tidy-text
          [actionBody]="'Add Note to Pro'"
          (action)="startEditNote(task)"
          class="link" />
      </tidy-row>
    }

    @if (editable && task.state === 'pending') {
      <tidy-row class="extra-top-padding">
        <tidy-text
          [actionBody]="'Remove Restocking Task'"
          (action)="onUnassign(task)"
          class="link red" />
      </tidy-row>
    }
  </tidy-card>
}
